let dietExpertAdmin = [
  {
    path: 'workbench',
    meta: {
      title: '方案工作台',
      breadcrumb: true
    },
    component: (resolve) => require(['@/views/plat/dietExpertAdmin/workbench'], resolve)
  },
  {
    path: 'advisoryAdmin',
    meta: {
      title: '咨询记录',
      breadcrumb: true
    },
    component: (resolve) => require(['@/views/plat/dietExpertAdmin/advisoryAdmin'], resolve)
  }
]


export default {
  path: '/dietExpertAdmin',
  redirect: '/dietExpertAdmin/workbench',
  meta: {
    title: "食疗专家后台",
    breadcrumb: true
  },
  component: {
    name: 'dietExpertAdmin',
    template: '<router-view></router-view>'
  },
  children: dietExpertAdmin
}


// WEBPACK FOOTER //
// ./src/router/dietExpertAdmin.js